export enum SavedFilterType {
  ownershipInstitution = 'OwnershipInstitution',
  ownershipFund = 'OwnershipFund',
  peerOwnership = 'PeerOwnership'
}
